import { render, staticRenderFns } from "./MemoriesRow.vue?vue&type=template&id=c50b7a20&scoped=true&"
import script from "./MemoriesRow.vue?vue&type=script&lang=js&"
export * from "./MemoriesRow.vue?vue&type=script&lang=js&"
import style0 from "./MemoriesRow.vue?vue&type=style&index=0&id=c50b7a20&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c50b7a20",
  null
  
)

export default component.exports